import ManualReasonApi from "@/api/masterData/manualReasonApi";

export default {
  namespaced: true,
  states: {
  },
  mutations: {

  },
  actions: {
    async addOrUpdate({dispatch}, form) {
      try {
        const response = await ManualReasonApi.addOrUpdate(form);
        return response.data;
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true})
      }
    },
    async fetch({dispatch}) {
      try {
        const response = await ManualReasonApi.fetch();
        return response.data;
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true})
      }
    },
    async remove({dispatch}, {id}) {
      try {
        const response = await ManualReasonApi.remove(id);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
